<template lang="html">
  <div id="payment-options-page">

    <section class="container oversized-container main-section">
      <div class="row">
        <div class="col-12">
          <div class="col-s-title">
            <h2 class="txt-blue title">Métodos de pago</h2>

            <p class="text-center text">
              Aceptalos las formas de pago más importantes.
            </p>
          </div>
        </div>
      </div>

      <div class="row justify-content-center">
        <div class="col-6 col-lg-4 col-xl-3 col-logo">
          <img src="public/images/pages/payments/check-plus.png">
        </div>

        <div class="col-6 col-lg-4 col-xl-3 col-logo">
          <img src="public/images/pages/payments/visa.png">
        </div>

        <div class="col-6 col-lg-4 col-xl-3 col-logo">
          <img src="public/images/pages/payments/mastercard.png">
        </div>

        <div class="col-6 col-lg-4 col-xl-3 col-logo">
          <img src="public/images/pages/payments/amex.png">
        </div>

        <div class="col-6 col-lg-4 col-xl-3 col-logo">
          <img src="public/images/pages/payments/coppel.png">
        </div>

        <div class="col-6 col-lg-4 col-xl-3 col-logo">
          <img src="public/images/pages/payments/fonacot.png">
        </div>

        <div class="col-6 col-lg-4 col-xl-3 col-logo">
          <img src="public/images/pages/payments/mejoravit.png">
        </div>
      </div>
    </section>
  </div>
</template>

<script>
export default {
}
</script>
